import React, { useEffect, useState } from 'react';
import { Router } from 'next/router';

export default function PageLoadingIndicator() {
  const [loaderState, setLoaderState] = useState(false);

  useEffect(() => {
    Router.events.on('routeChangeStart', () => {
      setLoaderState(true);
    });

    Router.events.on('routeChangeComplete', () => {
      setLoaderState(false);
      window.scrollTo(0, 0);
    });
  }, []);

  if (!loaderState) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  return /*#__PURE__*/(
    React.createElement("div", { className: "h-1 w-full absolute top-0 z-20 bg-indigo-100" }, /*#__PURE__*/
    React.createElement("div", { className: "w-full border-l-[16rem] border-indigo-700 h-full animate-indefinite" })));


}